'use strict';
var SoaModel = require('bunsen/models/SoaModel');
var ConversationMember = module.exports = SoaModel.extend();
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var bunsen = require('bunsen/libraries/bunsen');
var User = require('bunsen/models/identity/User');
var Party = require('bunsen/models/Party');
var newsy = require('newsy');
var endpoints = require('dibs-endpoints');
var userType = {
    external: 'EXTERNAL',
    seller: 'SELLER',
    buyer: 'BUYER'
};
var globalDataLogger = require('bunsen/libraries/globalDataLogger');
var copyText = require('copy-text')();
_.extend(ConversationMember, {
    userType: userType,
    newsy: 'ConversationMember',
    getMe : function (options) {
        var meInTheConversation;
        options = _.extend({
            userId: undefined,
            masquerade: false,
            masqueradeUserId: undefined,
            conversation: undefined
        }, options);
        meInTheConversation = newsy('ConversationMember', {
            conversation: {id: options.conversation.id}
        });
        // TODO: move this tricky masquerade logic into the entry file
        if (options.masquerade && options.masqueradeUserId) {
            globalDataLogger.event({'gotMeFromMasquerade': options.masqueradeUserId});
            meInTheConversation.set('user.id', options.masqueradeUserId);
        } else {
            globalDataLogger.event({'gotMeFromGotCurrentUser': options.userId});
            if (!options.userId) {
                throw new Error('expected options.userId in ConversationMember.getMe');
            }
            meInTheConversation.set('user.id', options.userId);
        }
        if (options.userType) {
            meInTheConversation.set('userType', options.userType);
        }
        return meInTheConversation;
    }
});
_.extend(ConversationMember.prototype, {
    url: _.compose(endpoints.conversationMembers, bunsen.getOn('id')),
    parse : function () {
        var data = ConversationMember.__super__.parse.apply(this, arguments);
        if (undefined === data.members) {
            return data; // we probably didn't get the data from endpoints.conversationMembers
        }
        if (data.members.length !== 1) {
            return data; // we don't know what to do with multiple members
        }
        return data.members[0].member;
    },
    defaults : {
        user: {},
        // conversation: {}, // messes with contact dealer
        userType: Party.ROLE_BUYER
    },
    relations : [{
        key : 'user',
        relatedModel: User,
        type : Backbone.One,
        saveJSONFields : ['id']
    }],
    getDisplayName: function () {
        var displayName = this.get('displayName');
        if ('string' === typeof displayName) {
            displayName = displayName.trim();
        }
        if (!displayName) {
            switch (this.get('userType')) {
                case userType.seller:
                    displayName = copyText.get('1stdibs dealer');
                    break;
                case userType.buyer:
                    displayName = copyText.get('1stdibs customer');
                    break;
                case userType.external:
                default:
                    displayName = copyText.get('3rd party');
                    break;
            }
        }
        return displayName;
    },
    isExternal: function () {
        return ConversationMember.userType.external === this.get('userType');
    },
    isDiscloseEmail: function () {
        return this.get('discloseEmail') === 'Y';
    },
    setDiscloseEmail: function (discloseEmail) {
        this.set('discloseEmail', discloseEmail ? 'Y' : 'N');
    },
    isOriginal: function () {
        return this.get('isOriginal') === 'Y';
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/usercomm/ConversationMember.js
// module id = 68
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56